export function getGenerateDocumentPath(documentId: string): string[] {
  return ['/documents', documentId];
}

export function getImportedDocumentPagePath(documentId: string): string[] {
  return ['/imported-document', documentId];
}

export function getImportedAnnualStatementPagePath(documentId: string): string[] {
  return ['/imported-annual-statement', documentId];
}

export function getGenerateDocumentInvoicePath(documentId: string): string[] {
  return ['/asic-invoices', documentId];
}

export function getCompanyProfilePath(companyId: string): string[] {
  return ['/companies', companyId];
}

export function getSharesPagePath(companyId: string): string[] {
  return ['/shares', companyId];
}

export function getTrustProfilePath(trustId: string): string[] {
  return ['/trusts', trustId];
}

export function getIndividualProfilePath(individualId: string): string[] {
  return ['/individuals', individualId];
}

export function getAnnualStatementsPath(statementId: string): string[] {
  return ['/annual-statements', statementId];
}
